<script setup lang="ts">
import type { ContentSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: ContentSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl flex justify-center">
    <div class="w-full lg:w-3/5">
      <StructuredContent :data="data.body" />
    </div>
  </div>
</template>

<style scoped>

</style>
